import {
	NewBrokerAccountData,
	OriasReturnable,
	SirenReturn,
} from "@dune/types";
import { ReactNode, createContext, useContext, useState } from "react";

interface OriasAndSirenContextType {
	oriasNumber: string;
	setOriasNumber: (number: string) => void;
	oriasData: OriasReturnable | null;
	setOriasData: (data: OriasReturnable) => void;
	sirenData: SirenReturn | null;
	setSirenData: (data: SirenReturn) => void;
	newBrokerAccountData: NewBrokerAccountData | null;
	setNewBrokerAccountData: (email: NewBrokerAccountData | null) => void;
}

const OriasAndSirenContext = createContext<
	OriasAndSirenContextType | undefined
>(undefined);

export const OriasAndSirenProvider = ({
	children,
}: { children: ReactNode }) => {
	const [oriasNumber, setOriasNumber] = useState<string>("");
	const [oriasData, setOriasData] = useState<OriasReturnable | null>(null);
	const [sirenData, setSirenData] = useState<SirenReturn | null>(null);
	const [newBrokerAccountData, setNewBrokerAccountData] =
		useState<NewBrokerAccountData | null>(null);

	return (
		<OriasAndSirenContext.Provider
			value={{
				oriasNumber,
				setOriasNumber,
				oriasData,
				setOriasData,
				sirenData,
				setSirenData,
				newBrokerAccountData,
				setNewBrokerAccountData,
			}}
		>
			{children}
		</OriasAndSirenContext.Provider>
	);
};

export const useOriasAndSirenContext = () => {
	const context = useContext(OriasAndSirenContext);
	if (!context) {
		throw new Error("useOriasContext must be used within an OriasProvider");
	}
	return context;
};
